import React from 'react'
import { useState, useRef, useContext } from 'react'
import UserContext from './../store/user-context'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import Field from './Field'
import { loginUser } from './../services/User/index'
import { Container, Form, Button } from 'react-bootstrap'

function SignIn() {
    const { setUserState } = useContext(UserContext);
    const [inputValues, setInputValues] = useState({ email: '', password: '' })
    const [btnClicked, setBtnClicked] = useState(false)
    const formRef = useRef()

    const inputChangeHandler = (e) => {
        setInputValues({
            ...inputValues,
            [e.target.name]: e.target.value.trimStart()
        });
    }

    const clearInputValues = () => {
        for (const input of formRef.current.querySelectorAll('input')) {
            input.value = ''
        }
        setInputValues({ email: '', password: '' })
    }

    const loginBtnHandler = async () => {
        if (btnClicked)
            return
        setBtnClicked(true)
        try {
            for (const key in inputValues) {
                if (inputValues[key].length === 0)
                    throw new Error(`${key} field is empty`)
            }
            const resp = await loginUser(inputValues)
            if (resp.success) {
                clearInputValues()
                toast.success('Logged In Successfully')
                localStorage.setItem('token', resp.token)
                localStorage.setItem('userId', resp.userId)
                const remainingMilliseconds = 60 * 60 * 1000;
                const expiryDate = new Date(
                    new Date().getTime() + remainingMilliseconds
                );
                localStorage.setItem('expiryDate', expiryDate.toISOString());
                setUserState({ isAuth: true, token: resp.token, userId: resp.userId })
            }
            else
                throw new Error(resp.error)
        } catch (error) {
            toast.error(error.message)
        }
        setBtnClicked(false)
    }

    const onEnterHandler = (e) => {
        if (e.key === 'Enter' && !btnClicked)
            loginBtnHandler()
    }

    return (
        <>
            <Container>
                <h3 className='text-center mb-4'>Sign in to your account</h3>
                <Form ref={formRef}>
                    <Field onEnterHandler={onEnterHandler} labelText='Email' name='email' type='email' placeholder='Enter Email' inputChangeHandler={inputChangeHandler} />
                    <Field onEnterHandler={onEnterHandler} labelText='Password' name='password' type='password' placeholder='Enter Password' inputChangeHandler={inputChangeHandler} />
                    <div className='text-center'>
                        <Button disabled={btnClicked} variant='success' className='mb-2' onClick={loginBtnHandler}>
                            Sign In
                        </Button>
                        <p>Don't have an account? <Link to='/signup' className='text-decoration-none'>Register</Link></p>
                    </div>
                </Form>
            </Container>
        </>
    )
}

export default SignIn